import {
  activeVariantConfig,
  broadcaster,
  CONSENT_CHANGED_BROADCAST_EVENT,
  environmentConfig,
  logger,
  retryBackoffStrategy,
  showConsentBannerUseCase,
} from '@otto-ec/eprivacy-shared'

import { ConsentProviderPort } from './ports'
import {
  informClientOnConsentChanged,
  isOneTrustEnabled,
  isOneTrustInternalHostingEnabled,
} from './core'
import { loadOneTrustConsentProviderFactory, onetrustConfig } from './adapters'
import { emitConsentChangeEvent } from '@otto-ec/eprivacy-cmp'

export const RETRY_CONFIG = [0, 200, 300, 500, 2500]

export async function bootstrap(): Promise<ConsentProviderPort | undefined> {
  try {
    showConsentBannerUseCase.hideInitial()

    if (!isOneTrustEnabled()) {
      logger.info('OneTrust is not enabled')
      return
    }
    const internalHosting: boolean = isOneTrustInternalHostingEnabled()
    const loadOnetrustConsentProvider = loadOneTrustConsentProviderFactory(
      logger,
      environmentConfig,
      internalHosting,
      retryBackoffStrategy(RETRY_CONFIG)
    )
    const variantConfig = await activeVariantConfig()
    const consentProvider = await loadOnetrustConsentProvider(
      onetrustConfig(environmentConfig),
      variantConfig.onetrustVariantId
    )

    /*                                                              */
    consentProvider.OnConsentChanged(async () => {
      await informClientOnOnetrustConsentChange(consentProvider)
    })

    broadcaster.receive(
      CONSENT_CHANGED_BROADCAST_EVENT,
      async () => await emitConsentChangeEvent()
    )

    return consentProvider
  } catch (e) {
    logger.error(
      new Error(`Failed to bootstrap onetrust-sdk`, {
        cause: e,
      })
    )
    return undefined
  }
}

async function informClientOnOnetrustConsentChange(
  consentProvider: ConsentProviderPort
) {
  try {
    await informClientOnConsentChanged(consentProvider, broadcaster)
  } catch (error) {
    logger.error(
      new Error(`Could not inform client on consent change`, { cause: error })
    )
  }
}
